export default "__VITE_ASSET__d4b536e4__"